var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-wrapper text-light"},[_c('div',{staticClass:"spinner-grow"}),_c('p',{staticClass:"mb-0 mt-3"},[_vm._v(_vm._s(_vm.message || "Loading..."))])])
}
var staticRenderFns = []

export { render, staticRenderFns }